/*
*
* Version : 1.0.0
* 04/09/2016 - 10h18
*
*! Octave Web7 !*/

(function () {
  'use strict';

  angular.module('app', [
    /* /angular */
    'ngSanitize',
    'ngAnimate',
    'ngCookies',
    'ngRoute',

    /* /lib */
    'ui.bootstrap',
    'module.lazy-img',
    'toastr',
    'bootstrap.angular.validation',
    'hl.sticky',
    'AngularGM',
    'smoothScroll',
    'module.spinner',

    /* /components */
    'component.input.quantity',
    'component.addtocart',
    'component.addtocart-quantity',
    'component.delete-cart-item',
    'component.modify-cart-item',

    /* /modules */
    'module.products-grid',
    'module.modal',
    'module.modal-controllers',

    /* /directives */
    'directive.mini-cart',
    'directive.owl-carousel',
    'directive.page-head',
    'directives.breadcrumb',
    'directive.collapse-menu',
    'directives.form',
    'directive.bootstrap-select',
    'directive.clear-uib-tab',
    'directive.video-player',
    'directive.flip',
    'directive.back-to-top',
    'directive.truncate',
    'directive.cookies-info',
    'directive.cdn',
    'directive.passwordValidator',

    /* /services */
    'service.app',
    'service.account',
    'service.http',
    'service.window-events',
    'service.responsive',
    'service.cdn',
    'service.date',
    'service.load',
    'service.gmap',

    /* /filters */
    'filter.price',
    'filter.discount',
    'filter.format',
    'filter.phone',

    'gulp-client',
    'gulp-dependencies',
    'gulp-routes',
    'gulp-templates',

    'directive.debug'
  ])

    /* Ne pas modifier, Gulp > master.min.js */
    .constant('Environment', 'dev')

    /* @ngInject */
    .controller('mainController', ["$scope", "$timeout", "$templateCache", "DeviceService", "HttpService", function ($scope, $timeout, $templateCache, DeviceService, HttpService) {
      var ctrl = this;

      setTimeout(function () {
        loadModalAddToCart();
      });

      $scope.$on('pageTitle', function (event, checkout) {
        $timeout(function () {
          ctrl.checkout = checkout;
        });
      });

      $scope.showPageLoader = false;
      $scope.$on('showPageLoader', function (event, value) {
        $scope.showPageLoader = value;
      });

      $scope.device = {};

      $scope.device.size = DeviceService.getSize($scope, function (size) {
        $scope.device.size = size;
        $scope.$emit('lazyImg:refresh');
      });

      $scope.device.xxs = DeviceService.onChange($scope, 'xxs', function (match) {
        $scope.device.xxs = match;
      });
      $scope.device.xs = DeviceService.onChange($scope, 'xs', function (match) {
        $scope.device.xs = match;
      });
      $scope.device.sm = DeviceService.onChange($scope, 'sm', function (match) {
        $scope.device.sm = match;
      });
      $scope.device.md = DeviceService.onChange($scope, 'md', function (match) {
        $scope.device.md = match;
      });
      $scope.device.lg = DeviceService.onChange($scope, 'lg', function (match) {
        $scope.device.lg = match;
      });

      $scope.device.desktop = DeviceService.onChange($scope, 'md, lg', function (match) {
        $scope.device.desktop = match;
      });
      $scope.device.mobile = DeviceService.onChange($scope, 'xxs, xs', function (match) {
        $scope.device.mobile = match;
      });

      $scope.device.isTouch = DeviceService.isTouch();

      $scope.device.isIe = DeviceService.isIE().isIE;
      $scope.device.ieVersion = DeviceService.isIE().isIE ? 'ie' + DeviceService.isIE().version : null;

      function loadModalAddToCart() {
        HttpService.get({
          url: '/Template/Modal/ModalAddToCart',
          cache: true
        })
          .then(function (data) {
            $templateCache.put('/Template/Modal/ModalAddToCart', data);
          })
          .catch(function (error) {
            console.error(error);
          });
      }

    }])

    /* @ngInject */
    .config(["$compileProvider", "Environment", function ($compileProvider, Environment) {
      // $qProvider.errorOnUnhandledRejections(false);
      $compileProvider.commentDirectivesEnabled(false);
      $compileProvider.cssClassDirectivesEnabled(false);
      if (Environment === 'prod') {
        $compileProvider.debugInfoEnabled(false);
      }
    }])

    /* @ngInject */
    .config(["lazyImgConfigProvider", function (lazyImgConfigProvider) {
      lazyImgConfigProvider.setOptions({
        offset: 100,
        errorClass: 'error',
        successClass: 'loaded'
      });
    }])

    /* @ngInject */
    .config(["usSpinnerConfigProvider", function (usSpinnerConfigProvider) {
      usSpinnerConfigProvider.setDefaults({
        color: '#344d65',
        lines: 15,
        length: 12,
        width: 2,
        radius: 10,
        opacity: 0
      });
      usSpinnerConfigProvider.setTheme('small', {
        length: 8,
        radius: 5
      });
      usSpinnerConfigProvider.setDelay(400);
    }])

    /* @ngInject */
    .config(["toastrConfig", function (toastrConfig) {
      angular.extend(toastrConfig, {
        timeOut: 3000,
        closeButton: true,
        closeHtml: '<button><i class="glyphicon glyphicon-remove"></i></button>',
        iconClasses: {
          success: ['success', 'glyphicon glyphicon-ok'],
          error: ['error', 'glyphicon glyphicon-exclamation-sign'],
          info: ['info', 'glyphicon glyphicon-info-sign'],
          warning: ['warning', 'glyphicon glyphicon-exclamation-sign']
        },
        templates: {
          toast: 'toast.tpl',
          progressbar: 'toast_progressbar.tpl'
        }
      });
    }])

    /* @ngInject */
    .config(["bsValidationConfigProvider", function (bsValidationConfigProvider) {
      bsValidationConfigProvider.global.setValidateFieldsOn(['blur', 'submit']);
      bsValidationConfigProvider.global.setDisplayErrorsAs('tooltip');
      bsValidationConfigProvider.global.tooltipAppendToBody = false;
      bsValidationConfigProvider.global.errorMessagePrefix = '<span class="glyphicon glyphicon-exclamation-sign"></span> &nbsp;';
    }])

    .config(["dropzoneOpsProvider", function (dropzoneOpsProvider) {
      dropzoneOpsProvider.setOptions({
        url: '/Upload',
        uploadMultiple: true,
        parallelUploads: 10,
        maxFilesize: '4',
        addRemoveLinks: true,
        renameFilename: function (name) {
          return new Date().getTime() + '_!_' + name;
        },
        dictRemoveFile: '<i class="glyphicon glyphicon-remove"></i>'
      });
    }])

    /* @ngInject */
    .run(["AppService", "bsValidationConfig", function (AppService, bsValidationConfig) {

      AppService.getParams();

      AppService.getTranslate()
        .then(function (translate) {
          _.each(translate.forms, function (value, key) {
            translate.forms[key] = value.replace('{validValue}', '{{validValue}}').replace('{matchName}', '{{matchName}}');
          });
          bsValidationConfig.setMessages(translate.forms);
        })
        .catch(function (error) {
          console.error(error);
        });

      window.onunload = function () { };

      PointerEventsPolyfill.initialize({});
    }]);

  angular.element(function () {
    angular.bootstrap(document, ['app'], {
      strictDi: true
    });
  });
})();
